module.exports = __webpack_public_path__ + "img/Google__G__logo.png";